






































import Vue, { PropType } from "vue";
import "@/components/icons";
import { Data, Methods, Computed, Props } from "./types";
import { sendGaEvent } from "@/helpers/ga-helper";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "Radio",
  props: {
    name: {
      type: String as PropType<Props["name"]>,
      default: ""
    },
    value: {
      type: String as PropType<Props["value"]>,
      required: true
    },
    label: {
      type: String as PropType<Props["label"]>,
      default: ""
    },
    checked: {
      type: Boolean as PropType<Props["checked"]>,
      default: false
    },
    disabled: {
      type: Boolean as PropType<Props["disabled"]>,
      default: false
    },
    size: {
      type: String as PropType<Props["size"]>,
      default: "small",
      validator(val) {
        return ["small", "medium"].includes(val);
      }
    },
    gaEventCategory: {
      type: String,
      default: ""
    }
  },
  computed: {
    iconSize() {
      return this.size === "medium" ? "16" : "14";
    }
  },
  methods: {
    updateValue(event: Event) {
      if (event.target instanceof HTMLInputElement) {
        sendGaEvent(this, {
          gaEventLabel: { value: this.value, label: this.label }
        });
        this.$emit("change", event.target.value);
      }
    }
  }
});
